import React, {useState} from 'react'
import './Register.css'
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import loadingGif from '../../Resources/loading2.gif'
import Navbar from '../Navbar/Navbar';
import BASE_URL from '../../constant';


export default function Register() {

    const [errmsg, setErrorMessage] = useState("");
    let msgStyle = {
        display : errmsg ? "flex" : "none"
    }

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [user, setUser] = useState({
        username : "",
        phone : "",
        email : "",
        password : "",
        reEnterPassword : "",
    });

    const handleChange = e =>{
        const {name, value} = e.target;
        setUser({
          ...user,
          [name] : value
        })
    }

    const handleSubmit = ()=>{

      setLoading(true);

      setTimeout(() => {
        setErrorMessage('');
      }, 5000);
        
      if(!user.username){
        setErrorMessage("Please enter your good Name :)");
        setLoading(false);
        return;
      }else if(!user.phone){
        setErrorMessage("Please provide your phone number :)");
        setLoading(false);
        return;
      }else if(!user.email){
        setErrorMessage("Please provide an email :)");
        setLoading(false);
        return;
      }else if(!user.password){
        setErrorMessage("Please enter a password :)");
        setLoading(false);
        return;
      }else if(!user.reEnterPassword){
        setErrorMessage("Please re-enter your password :)");
        setLoading(false);
        return;
      }else if(user.password !== user.reEnterPassword){
        setErrorMessage("Re-entered password does not match :)");
        setLoading(false);
        return;
      }else if(user.password.length <8){
        setErrorMessage("Password must be at least 8 characters :)");
        setLoading(false);
        return;
      }

      axios.post(`${BASE_URL}/bookmyshow/api/v1/auth/register`,user)
      .then(res => {
        setLoading(false);
        navigate('/login')
      })
      .catch(err=>console.error(err));

    }
    


    return (
      <>
      <Navbar />
    <div className='authContainer'>
        <div className="logalertmsg regalert" style={msgStyle} >
            <span className="msgtext" >
            {
                errmsg
            }
            </span>
            <span className="close-btn" onClick={()=>{setErrorMessage('')}}>×</span>
            <span className="line"></span>
        </div>
        <div className="form registerForm">
            <div className="heading">Create Account</div>
            <div className="flex">
                <div className="input-field">
                    <label htmlFor="username"><i className="fa-regular fa-user"></i> &nbsp;  Name</label>
                    <input required type="text" name="username" id="username" value={user.username} onChange={handleChange}/>
                </div>
                <div className="input-field">
                    <label htmlFor="phone"><i className="fa-solid fa-phone"></i>&nbsp; Phone no.</label>
                    <input required type="tel" name="phone" value={user.phone} onChange={handleChange} />
                </div>
            </div>
            <div className="input-field">
                <label htmlFor="email"><i className="fa-regular fa-envelope"></i>&nbsp; Email</label>
                <input required type="email" name="email" id="email" value={user.email} onChange={handleChange}/>
            </div>
            <div className="flex">
                <div className="input-field">
                    <label htmlFor="password"><i className="fa-solid fa-key"></i>&nbsp; Password</label>
                    <input required type="password" name="password" id="password" value={user.password} onChange={handleChange}/>
                </div>
                <div className="input-field">
                    <label htmlFor="reEnterPassword">Re-enter Password</label>
                    <input required type="password" name="reEnterPassword" id="reEnterPassword" value={user.reEnterPassword} onChange={handleChange}/>
                </div>
            </div>
            {
                (loading) ? 
                <button className='submitBtn loadsubmitBtn' type="submit">
                  <img src={loadingGif} alt="" /> Creating your account...
                </button>
                : 
                <button className='submitBtn' type="submit" onClick={handleSubmit}>Submit</button>
            }
            <div className="regLink">
                Already have an account ? &nbsp;
                <span className="changeLink">
                    <Link to='/login'>Login</Link>  
                </span>
            </div>
        </div>
    </div>
    </>
  )
}
